import React, { Component } from 'react';

import styled from 'styled-components';

import ProductCard from './ProductCard'
import Article from './../../Article';

const Wrapper = styled.div`
  @media (min-width: ${props => props.theme['mobileBreakpoint']}) {
    padding: 20px;
  }

  .product-smooth-open {
    animation: rollIn ease 2s;
    @keyframes rollIn { 
    0% { 
      transform: translate3d(0, -20%, 0);
    } 
    100% { 
      transform: none;
   } 
    }
    }
`;
export default class ProductListWrapper extends Component {

  render() {
    const {
      products,
      loadingAllProducts,
      loadingNextPage,
      loadProductsError,
    } = this.props;

    return (
      <Wrapper className={`row`}>
        {
          !loadProductsError
            && loadingAllProducts
            && <h3>Loading products.....</h3>
        }
        {
          !loadProductsError
            && !loadingAllProducts
            && products.map((product, id) => {
              if(product.category.name === "Articles") {
                return <Article key={id} className="col-12 p-0 product-smooth-open" {...product} />;
              } else {
                return <ProductCard key={id} className="col-6 col-lg-3 product-smooth-open" {...product} />;
              }
            })
        }
        {
          !loadProductsError
            && !loadingAllProducts
            && (!products || (products && products.length == 0))
            && <h3>No products found</h3>
        }
        {
          !loadProductsError
            && loadingNextPage
            && <h3>Loading more products</h3>
        }
        {
          loadProductsError
            && <h3>Error loading page, please refresh</h3>
        }
      </Wrapper>
    )
  }
}